import { BaseEntity } from "yt-ng-framework";

export class OsobaSrodstvo extends BaseEntity{
    constructor(){
        super();
    }

    OsobaID: number = null;
    SrodstvoID:number = null;
    SrodOsobaID: number = null;
    SamohraniRoditelj:boolean = null;
    Osiguranje:boolean = null;
    Lbo:number = null;

    Deserialize(input:any){
        this.ID=input.ID;
        this.OsobaID=input.OsobaID;
        this.SrodstvoID=input.SrodstvoID;
        this.SrodOsobaID=input.SrodOsobaID;
        this.SamohraniRoditelj=input.SamohraniRoditelj;
        this.Osiguranje=input.Osiguranje;
        this.Lbo=input.Lbo;
        return this;
    }

    Serialize(input:OsobaSrodstvo){
        return input;
    }
}